import { useLang } from "../context/LangContext";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, languages } = useLang();
  const active = languages.find((l) => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher-btn"
          className={`flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full transition-colors ${
            compact ? "h-9 px-3" : "h-10 px-4"
          }`}
        >
          <Globe className="h-4 w-4 text-white/70" />
          <span className="text-sm font-semibold uppercase">
            {active.code}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={6}
        className="bg-[#1c1c1e] border border-white/10 text-white min-w-[170px] rounded-2xl p-1.5"
      >
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`flex items-center gap-3 px-3 py-2 rounded-xl cursor-pointer ${
              lang === l.code
                ? "bg-[#007AFF]/15 text-white"
                : "text-white/80 hover:bg-white/5 focus:bg-white/5"
            }`}
          >
            <span className="text-base">{l.flag}</span>
            <span className="flex-1 text-sm font-semibold">{l.name}</span>
            {lang === l.code && <Check className="h-4 w-4 text-[#007AFF]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
